(() => {
  const initializeSliderArrows = (component) => {
    if (component.dataset.sliderArrowsInitialized === 'true') return;

    const slider = component.querySelector('.bestsellers-slider__grid.slider');
    const previousButton = component.querySelector('.bestsellers-slider__button--prev');
    const nextButton = component.querySelector('.bestsellers-slider__button--next');

    if (!slider || !previousButton || !nextButton) return;

    component.dataset.sliderArrowsInitialized = 'true';
    let frameRequested = false;

    const updateButtons = () => {
      frameRequested = false;
      const maximumScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);

      previousButton.toggleAttribute('disabled', slider.scrollLeft <= 1);
      nextButton.toggleAttribute('disabled', slider.scrollLeft >= maximumScroll - 1);
    };

    const requestUpdate = () => {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(updateButtons);
    };

    slider.addEventListener('scroll', requestUpdate, { passive: true });
    new ResizeObserver(requestUpdate).observe(slider);
    updateButtons();
  };

  const initializeAll = () => {
    document.querySelectorAll('.bestsellers-slider__component--nav').forEach(initializeSliderArrows);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const component = event.target.querySelector('.bestsellers-slider__component--nav');
    if (component) initializeSliderArrows(component);
  });
})();
